import React, {FC, PropsWithChildren, Suspense} from 'react';
import { Row } from 'reactstrap';
import NavMenu from './NavMenu';
import Top from './Top';
import Loading from './misc/Loading';

interface LayoutProps extends PropsWithChildren {
    navSection?: string,
}

const Layout: FC<LayoutProps> = props => <div>
    <Row className="layout">
        <div className="nav-left">
            <NavMenu activeSection={props.navSection} />
        </div>
        <div className="children">
            <Top />
            <Suspense fallback={<Loading />}>
                {props.children}
            </Suspense>
        </div>
    </Row>
</div>;
    
export default Layout;